const ADMIN_PERMISSIONS_KEY = 'adminPermissions'
const GCOP_KEY = 'GCOP'

function readJson(key, fallback) {
  const raw = localStorage.getItem(key)

  if (!raw) {
    return fallback
  }

  try {
    return JSON.parse(raw)
  } catch (error) {
    return fallback
  }
}

export function getAdminPermissions() {
  const permissions = readJson(ADMIN_PERMISSIONS_KEY, [])

  return Array.isArray(permissions) ? permissions : []
}

export function setAdminPermissions(permissions) {
  const normalizedPermissions = Array.isArray(permissions) ? permissions : []

  localStorage.setItem(ADMIN_PERMISSIONS_KEY, JSON.stringify(normalizedPermissions))
}

export function clearAdminPermissions() {
  localStorage.removeItem(ADMIN_PERMISSIONS_KEY)
}

export function isGcopEnabled() {
  return localStorage.getItem(GCOP_KEY) === 'true'
}

export function setGcopEnabled(value) {
  if (value) {
    localStorage.setItem(GCOP_KEY, 'true')
    return
  }

  localStorage.removeItem(GCOP_KEY)
}
